import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import Hero from './components/Hero';
import Image from '../BaseComponent/Image';
import TitleH4 from '../BaseComponent/TitleH4';
import Input from '../BaseComponent/Input';
import Select from '../BaseComponent/Select';
import $ from 'jquery';
import axios from 'axios'

class RegistrasiFood extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      newUser:{
        nameMitra: '',
        nameResto:'',
        email: '',
        telp: '',
        kotaResto: '',
        jmlMenu:'',
        npwp:'',
        jmlCab:'',
        namaResto:'',
        layanan:'',
        almResto:'',
        berdiri:'',
        posisi:'',
        findAt:'',
        status:''
      },
      cityOptions:["Malang", "Blitar","Surabaya"],
      layananOptions:["Ya","Tidak"],
      yearsOptions:["2000","2001","2004","2009"],
      findAtOptions:["Google","Temen","Instagram","Facebook","Twitter","Lainnya"],
      posisiOptions:["Dlm Gedung","Pinggir Jln","Pasar"],
      statusOptions:["Sewa","Milik Sendri"]
    };
  
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleClearForm = this.handleClearForm.bind(this);
    this.handleInput = this.handleInput.bind(this);
  }
  handleInput(e) {
    let value = e.target.value;
    let name = e.target.name;
    this.setState(
      prevState => ({
        newUser: {
          ...prevState.newUser,
          [name]: value
        }
      }),
      () => console.log(this.state.newUser)
    );
  }
  
  handleFormSubmit(e) {
    e.preventDefault();
    let userData = this.state.newUser;

    // fetch("http://debug.deliv.co.id:3000/api/mitra/register/driver", {
    //   method: "POST",
    //   body: JSON.stringify(userData),
    //   headers: {
    //     Accept: "application/json",
    //     "Content-Type": "application/json"
    //   }
    // }).then(response => {
    //   response.json().then(data => {
    //     console.log("Successful" + data);
    //   });
    // });

    axios({
      method: 'post',
      url: 'http://debug.deliv.co.id:3000/api/mitra/register/driver',
      data: userData,
      config: { headers: {'Content-Type': 'multipart/form-data' }}
      })
      .then(function (response) {
          //handle success
          console.log(response);
          console.log(userData);
      })
      .catch(function (response) {
          //handle error
          console.log(response);
      });
  }
  
  handleClearForm(e) {
  
    e.preventDefault();
    this.setState({ 
      newUser:{
        nameMitra: '',
        nameResto:'',
        email: '',
        telp: '',
        kotaResto: '',
        jmlMenu:'',
        npwp:'',
        jmlCab:'',
        namaResto:'',
        layanan:'',
        almResto:'',
        berdiri:'',
        posisi:'',
        findAt:'',
        status:''
      },
    });
}
  //  handleSubmit = (e, message) => {
  //   e.preventDefault()
  
  //   let formData = {
  //    formName: this.state.name,
  //    formCity: this.state.city,
  //    formType: this.state.type,
  //    formEmail: this.state.email,
  //    formGender: this.state.gender,
  //    formNopol: this.state.nopol,
  //    formTelp: this.state.telp,
  //    formVenicle: this.state.venicle,
  //    formYears: this.state.years,
  //    formFindAt: this.state.findAt,
  //    formMerk: this.state.merk
  //   }
  
  //   if (formData.formName.length < 1 || formData.formCity.length < 1 || formData.formType.length < 1 || 
  //     formData.formEmail.length < 1 || formData.formGender.length < 1 || formData.formNopol.length < 1 || formData.formTelp.length < 1 || formData.formVenicle.length < 1 || formData.formYears.length < 1 || formData.formFindAt.length < 1 || formData.formMerk.length < 1 ) {
  //    return false
  //   }
  
  //   $.ajax({
  //    url: 'http://debug.deliv.co.id:3000/api/mitra/register/driver',
  //    dataType: 'json',
  //    type: 'POST',
  //    data: formData,
  //    success: function(data){
  //        console.log(data);
  //    },
  //    error: function(xhr, status, err) {
  //     console.error(status, err.toString())
  //     alert('There was some problem with sending your message.')
  //    }
  //   })
  
  
  //   this.setState({
  //     nameMitra: '',
  //     email: '',
  //     telp: '',
  //     gender: '',
  //     venicle:'',
  //     type:'',
  //     merk:'',
  //     nopol:'',
  //     years:'',
  //     findAt:'',
  //     city:''
  //   })
   
  

   render() {
    return (
      <div>
        <Hero
        title="Registrasi Mitra DeFood"
        subtitle="Bergabung bersama ratusan Mitra Defood DELIV"
        />
        <section className="pendaftaran">
          <div className="container">
            <div className="columns">
              <div className="column is-flex">
              <Image
              styleName="image has-image-centered"
              image="img/registrasi/food.jpg"
              alt="Mitra DELIV"
              />
              </div>
              <div className="column is-offset-1 ">
                <div className="card">
                  <header className="card-header has-text-centered ">
                    <div className="card-header-title ">Registrasi Mitra Defood(Restoran)</div>
                  </header>
                  <div className="card-content">
                    <form onSubmit={this.handleFormSubmit} className="columns">                    
                      <div className="column ">
                        <div className="field">
                          <label htmlFor="" className="label is-small">
                            Nama
													</label>
                          <div className="control has-icons-left ">
                          <Input
                            inputType={"text"}
                            name={"nameMitra"}
                            value={this.state.newUser.nameMitra}
                            placeholder={"Nama"}
                            handleChange={this.handleInput}
                            styleName={"input is-small"}
                            />
                           
                            <span className="icon is-small is-left">
                              <i className="fas fa-user" />
                            </span>
                          </div>
                        </div>
                        <div className="field">
                          <label htmlFor="" className="label is-small">
                            Email
													</label>
                          <div className="control has-icons-left ">
                          <Input
                            inputType={"email"}
                            name={"email"}
                            value={this.state.newUser.email}
                            placeholder={"Email"}
                            handleChange={this.handleInput}
                            styleName={"input is-small"}
                            />
                           
                            <span className="icon is-small is-left">
                              <i className="fas fa-envelope" />
                            </span>
                          </div>
                        </div>
                        <div className="field">
                          <label htmlFor="" className="label is-small">
                            No. HP
													</label>
                          <div className="control has-icons-left ">
                          <Input
                            inputType={"number"}
                            name={"telp"}
                            value={this.state.newUser.telp}
                            placeholder={"Telp"}
                            handleChange={this.handleInput}
                            styleName={"input is-small"}
                            />
                          
                            <span className="icon is-small is-left">
                              <i className="fas fa-phone" />
                            </span>
                          </div>
                        </div>
                        <div className="field">
                          <label htmlFor="" className="label is-small">
                            Alamat Resto
													</label>
                          <div className="control has-icons-left ">
                          <Input
                            inputType={"text"}
                            name={"almResto"}
                            value={this.state.newUser.almResto}
                            placeholder={"Alamat Resto"}
                            handleChange={this.handleInput}
                            styleName={"input is-small"}
                            />
                          
                            <span className="icon is-small is-left">
                              <i className="fas fa-home" />
                            </span>
                          </div>
                        </div>

                        <div className="field">
                          <div className="control has-icons-left">
                            <label htmlFor="" className="label is-small">
                              Mengetahui Deliv?
														</label>
                            <div className="control has-icons-left">
                            <div className="select is-small is-fullwidth">
                            <Select
                            name="findAt"
                            options={this.state.findAtOptions}
                            value={this.state.newUser.findAt}
                            placeholder={"Pilih Info"}
                            handleChange={this.handleInput}
                            />
                            </div>
                            <span className="icon is-small is-left">
                              <i className="fas fa-globe" />
                            </span>
                          </div>
                            </div>
                        </div>
                      </div>
                      <div className="column">
                      <div className="field">
                         
                            <label htmlFor="" className="label is-small">
                              Kota Restoran
														</label>
                            <div className="control has-icons-left">
                            <div className="select is-small is-fullwidth">
                            <Select
                            name="kotaResto"
                            options={this.state.cityOptions}
                            value={this.state.newUser.city}
                            placeholder={"Pilih Kota"}
                            handleChange={this.handleInput}
                            />
                             
                            </div>
                            <span className="icon is-small is-left">
                              <i className="fas fa-map" />
                            </span>
                          </div>
                            
                        </div>
                        <div className="field">
                          
                            <label htmlFor="" className="label is-small">
                              NPWP (Bila ada)
														</label>
                            <div className="control has-icons-left">
                            <Input
                            inputType={"text"}
                            name={"npwp"}
                            value={this.state.newUser.npwp}
                            placeholder={"Nama Resto"}
                            handleChange={this.handleInput}
                            styleName={"input is-small"}
                            />
                              <span className="icon is-small is-left">
                              <i className="fas fa-book" />
                            </span>
                          </div>
                        </div>
                        <div className="field">
                         
                            <label htmlFor="" className="label is-small">
                              Nama Restoran
														</label>
                            <div className="control has-icons-left">
                            
                            <Input
                            inputType={"text"}
                            name={"namaResto"}
                            value={this.state.newUser.namaResto}
                            placeholder={"Nama Resto"}
                            handleChange={this.handleInput}
                            styleName={"input is-small"}
                            />
                            
                            <span className="icon is-small is-left">
                              <i className="fas fa-utensils" />
                            </span>
                          </div>
                        </div>
                        <div className="field">

                            <label htmlFor="" className="label is-small">
                              Berdiri Sejak
														</label>
                            <div className="control has-icons-left">
                            <Input
                            inputType={"text"}
                            name={"berdiri"}
                            value={this.state.newUser.berdiri}
                            placeholder={"tgl berdiri"}
                            handleChange={this.handleInput}
                            styleName={"input is-small"}
                            />
                            <span className="icon is-small is-left">
                              <i className="fas fa-vote-yea" />
                            </span>
                          </div>
                        </div>
                        <div className="field">
                            <label htmlFor="" className="label is-small">
                               Status Tempat
														</label>
                            <div className="control has-icons-left">
                            <div className="select is-small is-fullwidth">
                            <Select
                            name="status"
                            options={this.state.statusOptions}
                            value={this.state.newUser.status}
                            placeholder={"Status Tempat"}
                            handleChange={this.handleInput}
                            />
                            </div>
                            <span className="icon is-small is-left">
                              <i className="fas fa-calendar-alt" />
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="column">
                        <div className="field">
                          <label htmlFor="" className="label is-small">
                            Jumlah Menu
													</label>
                          <div className="control has-icons-left ">
                          <Input
                            inputType={"number"}
                            name={"jmlMenu"}
                            value={this.state.newUser.jmlMenu}
                            placeholder={"Jumlah Menu"}
                            handleChange={this.handleInput}
                            styleName={"input is-small"}
                            />

                            <span className="icon is-small is-left">
                              <i className="fas fa-book-open" />
                            </span>
                          </div>
                        </div>
                        <div className="field">
                            <label htmlFor="" className="label is-small">
                              Jumlah Cabang
														</label>
                            <div className="control has-icons-left">
                            <Input
                            inputType={"number"}
                            name={"jmlCab"}
                            value={this.state.newUser.jmlCab}
                            placeholder={"Jmlh Cabang"}
                            handleChange={this.handleInput}
                            styleName={"input is-small"}
                            />
                            <span className="icon is-small is-left">
                              <i className="fas fa-landmark" />
                            </span>
                          </div>
                        </div>
                        <div className="field">
                            <label htmlFor="" className="label is-small">
                               Layanan Antar
														</label>
                            <div className="control has-icons-left">
                            <div className="select is-small is-fullwidth">
                            <Select
                            name="layanan"
                            options={this.state.layananOptions}
                            value={this.state.newUser.layanan}
                            placeholder={"layanan antar"}
                            handleChange={this.handleInput}
                            />
                            </div>
                            <span className="icon is-small is-left">
                              <i className="fas fa-calendar-alt" />
                            </span>
                          </div>
                        </div>
                        <div className="field">
                            <label htmlFor="" className="label is-small">
                               Posisi Restoran
														</label>
                            <div className="control has-icons-left">
                            <div className="select is-small is-fullwidth">
                            <Select
                            name="posisi"
                            options={this.state.posisiOptions}
                            value={this.state.newUser.posisi}
                            placeholder={"Posisi Resto"}
                            handleChange={this.handleInput}
                            />
                            </div>
                            <span className="icon is-small is-left">
                              <i className="fas fa-calendar-alt" />
                            </span>
                          </div>
                        </div>                        
                        <div className="field is-flex is-horizontal-center">
                          <div className="control">
                            <br />
                            <button className="button is-link is-small" type="submit ">Submit</button>
                          </div>
                        </div>
                      </div>
                      </form>
                    
                  </div>
                </div>
              </div>
              {/* End Column */}
            </div>
            {/* End Columns */}
            {/* Start Reason Registrasi */}
          </div>
        </section>
        <section id="pendaftaran-alasan">
          <div className="container">
            <div className="content has-text-centered">
              <Fade left>
                <h2 className="title is-uppercase">Bergabunglah dengan Deliv</h2>
                <p className="subtitle">Kenali kami lebih jauh</p>
              </Fade>
            </div>
            <div className="columns">
              <Fade left cascade>
                <div className="column galery_registrasi ">
                <Image
                styleImage="image"
                image="/img/registrasi/food-1.jpg"
                />
                <Image
                styleImage="image"
                image="/img/registrasi/food-2.JPG"
                />
                <Image
                styleImage="image"
                image="/img/registrasi/food-3.JPG"
                />
                <Image
                styleImage="image"
                image="/img/registrasi/food-4.jpg"
                />
                </div>
              </Fade>
              <div className="column font-small">
                <ul>
                  <li>
                    <Fade left>
                    <TitleH4 
                    title="Karya Anak Bangsa"
                    subtitle=" Para driver yang terpercaya dan berkendaran dengan nyaman dan aman
                    menjadi salah satu poin utama kami"
                    />
                    </Fade>
                  </li>
                  <li>
                    <Fade left>
                      <TitleH4
                      title="Akses ke Pelanggan"
                      subtitle="Raih lebih banyak pelanggan dengan menjadi mitra defood kami dengan akses  ke berbagai layanan DELIV"
                      />
                    </Fade>
                  </li>
                  <li>
                    <Fade left>
                    <TitleH4
                    title="Promosi Melalui Aplikasi"
                    subtitle="Tampilkan menu unggulan dan lokasi restoran anda untuk promosi dilayanan DELIV"
                    />
                    </Fade>
                  </li>
                  <li>
                    <Fade left>
                      <TitleH4
                      title="Potensi Bisnis"
                      subtitle="Perluas potensi bisnis restoran anda dengan mendapatkan pelanggan DELIV dan driver DELIV yang siap mengantarkan produk anda ke pelanggan"
                      />
                    </Fade>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default RegistrasiFood;
